<template>
  <v-row class="mt-5 ml-4 mr-4" v-if="!initializing">
    <v-col
      cols="1"
      style="display: flex; align-items: center; justify-content: center"
    >
      <span>Select: </span>
    </v-col>
    <v-col cols="3">
      <v-select
        v-model="typeToDisplay"
        :items="[
          { value: 'ALL', text: 'All data' },
          { value: 'GENERATED', text: 'Only generated data' },
          { value: 'NONGENERATED', text: 'Only non-generated data' }
        ]"
      ></v-select>
    </v-col>
    <v-col cols="1">
      <exo-help-dialog
        :color="'white-text'"
        :margin="'ma-2'"
        title="Data type selection"
      >
        <tooltipDataTypeSelection />
      </exo-help-dialog>
    </v-col>
    <template v-if="typeToDisplay !== 'NONGENERATED'">
      <v-col
        cols="3"
        style="display: flex; align-items: center; justify-content: center"
      >
        <span>Only select generated data from the following missions: </span>
      </v-col>
      <v-col cols="3"
        ><v-select
          v-model="selectedIds"
          :items="idSelectorItems"
          multiple
          :placeholder="'No data from missions'"
          :no-data-text="'You have currently no data generation mission'"
          ><template
            v-slot:prepend-item
            v-if="simulationIdsInDatabase.length > 0"
          >
            <v-list-item ripple @mousedown.prevent @click="toggle">
              <v-list-item-action>
                <v-icon
                  :color="selectedIds.length > 0 ? 'indigo darken-4' : ''"
                >
                  {{ icon }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Select All </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider> </template
        ></v-select>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import errorMixin from '@/mixins/logHandler'
import tooltipDataTypeSelection from '../../components/Tooltips/Defense/tooltipDataTypeSelection'

export default {
  name: 'SimulationIdSelector',

  mixins: [errorMixin],

  components: {
    tooltipDataTypeSelection
  },

  props: {
    updating: {
      type: Boolean,
      default: false
    },
    typeToDisplayProp: {
      validator(value) {
        return ['ALL', 'GENERATED', 'NONGENERATED'].includes(value)
      },
      default: 'ALL'
    },
    selectedIdsProp: {
      default: () => []
    }
  },

  watch: {
    updating(newValue) {
      if (newValue) {
        this.$emit('update:updating', false)
        this.updateSimulationIdsInDatabase()
      }
    },
    simulationIds(newValue) {
      this.$emit('list-updated', newValue)
    }
  },

  async mounted() {
    this.init()
  },

  beforeDestroy() {},

  computed: {
    ...mapGetters({ currentUser: 'currentUser', missions: 'missions' }),
    dataGeneratorRequestIdToName() {
      return this.missions.reduce((partialResult, mission) => {
        return { ...partialResult, [mission.id]: mission.name }
      }, {})
    },
    idSelectorItems() {
      return this.simulationIdsInDatabase.map((id) => {
        return { text: this.getNameFromSimulationId(id), value: id }
      })
    },
    typeToDisplay: {
      get() {
        return this.typeToDisplayProp
      },
      set(newValue) {
        this.$emit('update:typeToDisplayProp', newValue)
      }
    },
    selectedIds: {
      get() {
        return this.selectedIdsProp || []
      },
      set(newValue) {
        this.$emit('update:selectedIdsProp', newValue)
      }
    },
    allIdsSelected() {
      return this.selectedIds.length === this.simulationIdsInDatabase.length
    },
    someIdsSelected() {
      return this.selectedIds.length > 0 && !this.allIdsSelected
    },
    icon() {
      if (this.allIdsSelected) {
        return 'check_box'
      } else if (this.someIdsSelected) {
        return 'indeterminate_check_box'
      } else {
        return 'check_box_outline_blank'
      }
    }
  },
  data() {
    return {
      simulationIdsInDatabase: [],
      initializing: true
    }
  },
  methods: {
    ...mapActions(['loadMissions']),
    async init() {
      this.initializing = true
      await this.loadMissions(this.$root)
      await this.updateSimulationIdsInDatabase()
      if (this.selectedIdsProp == null) {
        this.selectedIds = this.simulationIdsInDatabase.slice()
      }
      this.initializing = false
    },
    getNameFromSimulationId(id) {
      if (id !== 'null') {
        return this.dataGeneratorRequestIdToName[id] || `Deleted mission(${id})`
      }
    },

    async updateSimulationIdsInDatabase() {
      this.simulationIdsInDatabase = await this.$http
        .get(`/users/${this.currentUser.id}/spmeasurements/simulationids`)
        .then((response) =>
          response.data
            .filter((id) => id !== 'null')
            .sort(
              (id1, id2) =>
                this.getNameFromSimulationId(id1) >
                this.getNameFromSimulationId(id2)
            )
        )
        .catch((e) => {
          this.displayMessage(
            'Error while getting simulation ids.',
            e,
            'notification',
            'error'
          )
          return null
        })
    },
    toggle() {
      this.$nextTick(() => {
        if (this.allIdsSelected) {
          this.selectedIds = []
        } else {
          this.selectedIds = this.simulationIdsInDatabase.slice()
        }
      })
    }
  }
}
</script>
